import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogWrapper } from '../../../../shared/components/common/dialogWrapper';
import { FsButton } from '../../../../shared/components/button';
import { InvestorDeclarationDialog } from '../../investor/views/declarationDialog';

export const IwillDoItLaterDialog = ({
	state,
	onClose = (e) => { },
	isProfessional = false,
	isCorporate = false,
	isBorrower = false,
	testId = 'iwilldoitlaterId',
}) => {
	const { t } = useTranslation();
	const [showDeclarationPopup, setShowDeclarationPopup] = useState(false);

	const onIWillDoItLater = () => {
		if (isBorrower) {
			onClose('skip');
		} else {
			setShowDeclarationPopup(true);
		}
	};

	const isHideCashbackMsg = () => true;

	return (
		<>
			<DialogWrapper
				testId={testId}
				maxWidth={isHideCashbackMsg() ? 'xs' : 'sm'}
				state={state}
				onClose={() => {
					onClose();
				}}
				title={isHideCashbackMsg() ? t('confirmation') : t('dontMiss3Cashback')}
				content={
					<Box className="text-center">
						{isHideCashbackMsg() ? <>
							<p>{t('areYouSureSkipThisStep')}</p>
							<p>{t('weWillNeedDocumentsToOpenAccountLater')}</p>
						</> : <>
							<span>{t('completeYourSignup')}</span>
						</>}

					</Box>
				}
				actions={
					<Box className="flex flex-col space-y-6">
						<Box className="flex justify-center">
							<FsButton
								onClick={() => {
									onIWillDoItLater();
								}}
								variant="outline">{t('doItLater')}</FsButton>
							<Box className="w-2"></Box>
							<FsButton
								onClick={() => {
									onClose();
								}}>{t('upload')}</FsButton>
						</Box>
					</Box>
				}></DialogWrapper>
			{showDeclarationPopup ? (
				<InvestorDeclarationDialog
					isUploadedAllDocuments={false}
					state={showDeclarationPopup}
					onClose={(e) => {
						setShowDeclarationPopup(false);
						if (e) {
							onClose();
						}
					}}></InvestorDeclarationDialog>
			) : null}
		</>
	);
};
